import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCopyIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.626 6C13.5235 6 14.251 6.72754 14.251 7.625V12.625C14.251 13.5225 13.5235 14.25 12.626 14.25H8.62598C7.72852 14.25 7.00098 13.5225 7.00098 12.625V7.625C7.00098 6.72754 7.72852 6 8.62598 6H12.626ZM8.62598 7.25C8.41887 7.25 8.25098 7.41789 8.25098 7.625V12.625C8.25098 12.8321 8.41887 13 8.62598 13H12.626C12.8331 13 13.001 12.8321 13.001 12.625V7.625C13.001 7.41789 12.8331 7.25 12.626 7.25H8.62598ZM8.69141 1.99121C9.58879 1.99121 10.3163 2.71886 10.3164 3.61621V4.70605H9.06641V3.61621C9.06628 3.40922 8.89844 3.24121 8.69141 3.24121H4.69141C4.48447 3.24131 4.31654 3.40928 4.31641 3.61621V9.61621C4.31641 9.82326 4.48439 9.99111 4.69141 9.99121H5.80274V11.2412H4.69141C3.79403 11.2411 3.06641 10.5136 3.06641 9.61621V3.61621C3.06654 2.71892 3.79411 1.99131 4.69141 1.99121H8.69141Z",
		fill: "currentColor"
	})
});
export default SvgCopyIcon;
